import { render, staticRenderFns } from "./ExpireModal.vue?vue&type=template&id=64470073&scoped=true&"
import script from "./ExpireModal.vue?vue&type=script&lang=js&"
export * from "./ExpireModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpireModal.vue?vue&type=style&index=0&id=64470073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64470073",
  null
  
)

export default component.exports